"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginCode = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var mona_1 = require("@artegeie/design-system/mona");
var user_1 = require("@artegeie/mona-sdk/user");
var useFormattedMessages_1 = __importDefault(require("../../../context/useFormattedMessages"));
var LoginCodeInput_1 = __importDefault(require("./LoginCodeInput"));
var text_1 = require("../../text");
var style_1 = require("../../style");
var LoginCode = function () {
    var messages = (0, useFormattedMessages_1.default)('form.profile.tvlogin');
    var _a = (0, react_1.useState)(undefined), loginCode = _a[0], setLoginCode = _a[1];
    (0, react_1.useEffect)(function () {
        (0, user_1.getLoginCode)()
            .then(setLoginCode);
    }, []);
    return (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)(style_1.Spacer, __assign({ spacer: mona_1.mSpacer }, { children: (0, jsx_runtime_1.jsx)(text_1.Title, { children: messages.title }, void 0) }), void 0), loginCode && (0, jsx_runtime_1.jsx)(LoginCodeInput_1.default, { code: loginCode.code }, void 0)] }, void 0);
};
exports.LoginCode = LoginCode;
exports.default = exports.LoginCode;
